import { PlusOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import PageTitle from '../../../components/PageTitle'
import { MODULE_CODE } from '../../../constants'
import DocumentsLayout from '../../../layouts/DocumentsLayout/DocumentsLayout'
import InternalDocumentDeletedConfig from './InternalDocumentDeletedConfig'

const InternalDocumentDeletedPage = props => {
  const history = useHistory()

  return !props.isDocumentManagementTab ? (
    <DocumentsLayout
      title={
        <PageTitle location={props.location} title="Văn bản đến" hiddenGoBack>
          <Button
            icon={<PlusOutlined />}
            type="primary"
            style={{ visibility: 'hidden' }}>
            Button
          </Button>
        </PageTitle>
      }
      selectedKey="deleted"
      linkToIncomingDocument="/internal-document/incoming-document"
      linkToOutgoingDocument="/internal-document/outgoing-document">
      <div style={{ display: 'flex', minHeight: 'calc(100vh - 200px)' }}>
        <div style={{ flexGrow: 1 }}>
          <InternalDocumentDeletedConfig />
        </div>
      </div>
    </DocumentsLayout>
  ) : (
    <InternalDocumentDeletedConfig />
  )
}

InternalDocumentDeletedPage.propTypes = {}

export default inject('moduleStore')(observer(InternalDocumentDeletedPage))
